import React from 'react';
import './toast.css';

const Toast = ({ message, type, show }) => {
  const safeMessage =
    typeof message === "string"
      ? message
      : JSON.stringify(message); // 👈 prevents crash
  console.log(message);
  return (
    <div className={`toast ${type} ${show ? 'show' : ''}`}>
      {safeMessage}
    </div>
  );
};

export default Toast;